export const VIDEO_HEIGHT = 720;
export const VIDEO_WIDTH = 1280;
export const MIN_VIDEO_HEIGHT = 360;
export const MIN_VIDEO_WIDTH = 640;
export const DEFAULT_ASPECT_RATIO = 4 / 3;
export const MOBILE_VIDEO_HEIGHT = 200;
export const MOBILE_VIDEO_WIDTH = 160;
